import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  adminData: {
    firstName: "",
    lastName: "",
    email: "",
    image: null,
  },
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setAdminData: (state, action) => {
      state.adminData = action.payload;
    },
    updateAdminImage: (state, action) => {
      state.adminData.image = action.payload;
    },
    clearAdminData: (state) => {
      state.adminData = initialState.adminData;
    },
  },
});

export const { setAdminData, updateAdminImage, clearAdminData } =
  adminSlice.actions;
export default adminSlice.reducer;
